import React from 'react';
import { FaArrowTrendUp } from 'react-icons/fa6';
import './CaseStudy.scss';

const CaseStudy: React.FC = () => (
  <div className="case-study-container">
    <span className="case-study-label">Resultados reales</span>
    <h2 className='case-study-title'>Lo que nos mueve</h2>
    <p className="case-study-description">
      Desde el día uno, construimos <span>MedioPunto</span> para restaurantes con operaciones reales.
      Simplificamos el trabajo en sala, la gestión de inventario y proveedores, la centralización
      de pedidos y el control financiero de tu negocio.
    </p>

    <section className="case-study">
      <div className="card card--optimize">
        <div className="title-container">
          <h3 className="card-title">Tú eres el centro</h3>
          <h4 className="card-subtitle">Nosotros, el soporte</h4>
        </div>
        <img
          className="card__image"
          src={`${process.env.PUBLIC_URL}/web_page_images/diet_salvatore.png`}
          alt="Tú eres el centro"
        />
      </div>

      <div className="card card--speedy">
        <div className="card__text-block">
          <h3 className="card__title">Reseñas en tiempo real</h3>
          <p className="card__text">Escucha lo que tus clientes quieren decirte, al instante.</p>
        </div>
        <img
          className="card__image"
          src={`${process.env.PUBLIC_URL}/web_page_images/feedback-comments.png`}
          alt="Client feedback"
        />
      </div>

      <div className="card card--reservations">
        <h3 className="card__title">Inventario con IA</h3>
        <p className="card__text">
          Olvídate de horas ingresando productos. MedioPunto usa inteligencia artificial
          para registrar tu inventario en segundos.
        </p>
        <img
          className="card__image"
          src={`${process.env.PUBLIC_URL}/web_page_images/optimiza-tiempo.png`}
          alt="Inventario con IA"
        />
      </div>

      <div className="card card--review">
        <img
          className="review-logo"
          src={`${process.env.PUBLIC_URL}/web_page_images/logo_salvatore.png`}
          alt="Da Salvatore"
        />
        <div className="review-content">
          <div className="review-stats">
            <FaArrowTrendUp />
            <span>+15% ticket promedio</span>
          </div>
          <blockquote className="review-quote">
            Desde que usamos MedioPunto, el ticket promedio subió un 15%. Todo fluye:
            los pedidos salen más rápido, ya no se pierde comida y nos olvidamos de
            los errores. Un antes y un después.
          </blockquote>
          <div className="review-signature">Salvatore Viveros</div>
          <div className="review-author-info">Dueño y Chef — Da Salvatore, Quilpué</div>
        </div>
      </div>
    </section>
  </div>
);

export default CaseStudy;
